export default "__VITE_ASSET__DVoT0XCD__"